(function () {
  'use strict';
  function init(root) {
    if (root.dataset.rtInit === '1') return;
    root.dataset.rtInit = '1';
    var clip = root.querySelector('[data-rt-clip]');
    var toggle = root.querySelector('[data-rt-toggle]');
    if (!clip || !toggle) return;
    function evaluate() {
      if (root.classList.contains('is-open')) { toggle.hidden = false; return; }
      toggle.hidden = clip.scrollHeight <= clip.clientHeight + 4;
    }
    toggle.addEventListener('click', function () {
      var open = root.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    evaluate();
    window.addEventListener('resize', evaluate);
    window.addEventListener('load', evaluate);
    setTimeout(evaluate, 300);
  }
  function all() { document.querySelectorAll('[data-rt]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', function (e) { var el = e.target.querySelector('[data-rt]'); if (el) init(el); });
})();
